import React from 'react';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <div className="bg-indigo-700" data-id="element-9">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between" data-id="element-10">
        <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-11">
          <span className="block" data-id="element-12">
            Ready to supercharge your content strategy?
          </span>
          <span className="block text-indigo-200" data-id="element-13">
            Start converting your videos today.
          </span>
        </h2>
        <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0" data-id="element-14">
          <div className="inline-flex rounded-md shadow" data-id="element-15">
            <a href="#" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-indigo-50" data-id="element-16">
              Get started
              <ArrowRight className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" data-id="element-17" />
            </a>
          </div>
          <div className="ml-3 inline-flex rounded-md shadow" data-id="element-18">
            <a href="#" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 bg-opacity-60 hover:bg-opacity-70" data-id="element-19">
              Learn more
            </a>
          </div>
        </div>
      </div>
    </div>;
}